import setCssVar from './setCssVar';

const setPromoBannerVisibleHeightCssVar = height => {
  setCssVar('--visible-promotion-banner-height', height);
};

export default setPromoBannerVisibleHeightCssVar;
